import {
  AssetWithDocumentProps,
  FilePreviewType,
  FileResolutionProps,
  FileViewMode,
  FileWithError,
} from './UploadArea.types'

export const minImageWidthInPx = 1300

interface GetFileNamesWithErrorProps {
  files: AssetWithDocumentProps[]
  filesWithError: FileWithError
}

export const getFileNamesWithError = ({ files, filesWithError }: GetFileNamesWithErrorProps) => {
  const fileIdsWithError = Object.keys(filesWithError)
  const fileNamesWithError = files
    .filter(file => fileIdsWithError.includes(file.id) && !!file.fileName)
    .map(file => String(file.fileName))

  return fileNamesWithError
}

export const getFileSizeByType = (
  filePreviewType?: FilePreviewType,
  fileViewMode?: FileViewMode,
) => {
  if (filePreviewType === FilePreviewType.photoGallery) {
    return fileViewMode === FileViewMode.list
      ? {
          width: 212,
          height: 212,
        }
      : {
          width: 168,
          height: 188,
        }
  }

  return {
    width: 104,
    height: 104,
  }
}

export const getPreviewTitleByType = (
  filePreviewType?: FilePreviewType,
  files?: AssetWithDocumentProps[],
) => {
  if (filePreviewType === FilePreviewType.photoGallery) {
    const disabledLength = files?.filter(file => file.disabled)?.length
    const enabledLength = files?.filter(file => !file.disabled)?.length

    return (
      <>
        Photo Gallery &bull; {files?.length} photos{' '}
        {disabledLength ? <>&bull; {enabledLength} selected</> : null}
        {disabledLength ? <>&bull; {disabledLength} disabled</> : null}
      </>
    )
  }

  return <>Files &bull; {files?.length} </>
}

export const getImageDimensions = async (imageUrl: string): Promise<FileResolutionProps> => {
  return new Promise((resolve, reject) => {
    const img = new Image()
    img.onload = () => resolve({ width: img.width, height: img.height })
    img.onerror = reject
    img.src = imageUrl
  })
}
